export default "__VITE_ASSET__BvQJO3y8__"